import { AssignProjectMilestone } from '../../../domain/projectMilestones/assignProjectMilestone';
import { CreateMilestoneTask } from '../../../domain/projectMilestones/createMilestoneTask';
import { CreateProjectMilestone } from '../../../domain/projectMilestones/createProjectMilestone';
import { ProjectMilestoneListModel } from '../../../domain/projectMilestones/projectMilestoneListModel';
import { UpdateMilestoneTaskModel } from '../../../domain/projectMilestones/updateMilestoneTaskModel';
import { UpdatedProjectMilestone } from '../../../domain/projectMilestones/updateProjectMilestone';
import { UpdatedProjectMilestoneProject } from '../../../domain/projectMilestones/updateProjectMilestoneProject';
import { ProjectMilestoneAdapter } from '../../adapters/projectMilestone/projectMilestoneAdapters';
import { MilestoneSelectorDTO } from '../../http/dtos/projectMilestones/milestoneSelectorDTO';
import { ProjectMilestoneDTO } from '../../http/dtos/projectMilestones/projectMilestoneDTO';
import { ProjectMilestoneListDTO } from '../../http/dtos/projectMilestones/projectMilestoneListDTO';
import httpClient from '../../http/httpClient';

export const ProjectMilestoneRepository = {
    GetProjectMilestoneList: () => {
        return httpClient
            .get('/project-milestone/project-milestone-filtered-list')
            .then((response: ProjectMilestoneListDTO[]) =>
                ProjectMilestoneAdapter.getProjectMilestoneListAdapter(response)
            );
    },

    GetProjectMilestone: (id: string) => {
        return httpClient
            .get('/project-milestone/project-milestone-by-id/' + id)
            .then((response: ProjectMilestoneDTO) =>
                ProjectMilestoneAdapter.getProjectMilestoneAdapter(response)
            );
    },

    CreateProjectMilestone: (newProjectMilestone: CreateProjectMilestone) => {
        return httpClient
            .post('/project-milestone/create-project-milestone', newProjectMilestone)
            .then((response) => response);
    },

    UpdateProjectMilestone: (
        id: number,
        newProjectMilestone: UpdatedProjectMilestone
    ) => {
        return httpClient
            .put(
                '/project-milestone/update-project-milestone/' + id,
                newProjectMilestone
            )
            .then((response) => response);
    },

    GetProjectMilestoneListTable: (projectId: string) => {
        return httpClient
            .get(`/project-milestone/project-milestone-list?projectId=${projectId}`)
            .then((response: ProjectMilestoneListModel[]) =>
                ProjectMilestoneAdapter.getProjectMilestoneListTableAdapter(response)
            );
    },

    UpdateProjectMilestoneProject: (
        newProjectMilestone: UpdatedProjectMilestoneProject,
        id: number
    ) => {
        return httpClient
            .put(
                '/project-milestone/update-project-milestone-project/' + id,
                newProjectMilestone
            )
            .then((response) => response);
    },

    GetMilestonesList: () => {
        return httpClient
            .get('/project-milestone/milestone-list')
            .then((response: MilestoneSelectorDTO[]) => response);
    },

    AssignProjectMilestone: (
        id: string,
        newProjectMilestone: AssignProjectMilestone[]
    ) => {
        return httpClient
            .post(
                '/project-milestone/assign-project-milestone/' + id,
                newProjectMilestone
            )
            .then((response) => response);
    },

    /**
     * Request for creation of new milestone Task 
     * @param id milestone Id
     * @param model 
     * @returns comments, estimatedHours, actualWorkHours, completedDate
     */
    CreateTasksByMilestone: (
        id : number,
        model : CreateMilestoneTask
    ) => {
        return httpClient
            .post(
                '/project-milestone/'+id+'/task',
                model
            )
            .then((response) => response);
    },
    /**
     * Request for update a Milestone Task
     * @param id Milestone Id
     */
    UpdateProjectMilestoneTask: (
        id: number,
        model: UpdateMilestoneTaskModel
    ) => {
        return httpClient
            .patch(
                '/project-milestone/tasks/' + id,
                model
            )
        .then((response) => response);
    },
};
